import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ClosureDetail } from '../../../models';

@Component({
  selector: 'app-closure-specifications',
  templateUrl: './closure-specifications.component.html',
  styleUrls: ['./closure-specifications.component.scss']
})
export class ClosureSpecificationsComponent implements OnInit {
  @Input() showLoader = false;
  @Input() product?: ClosureDetail | null;
  @Input() hasDrawing = false;
  @Input() configurationFilter?: FormGroup;
  @Input() additionalDrawings: string[] = [];
  @Input() showHeader = true;

  @Output() getFittingDrawing = new EventEmitter<string>();
  @Output() getClosureDrawing = new EventEmitter<ClosureDetail>();
  @Output() getClosureAssociatedDrawing = new EventEmitter<string>();
  constructor() { }

  ngOnInit(): void {
  }

}
